import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

interface VacationBannerProps {
  startDate: string;
  endDate: string;
}

export const VacationBanner: React.FC<VacationBannerProps> = ({ startDate, endDate }) => {
  const { t } = useLanguage();

  const formatDate = (dateString: string) => {
    // Add T12:00:00 to avoid timezone shift when parsing date-only strings
    const dateStr = dateString.includes('T') ? dateString : dateString + 'T12:00:00';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="vacation-banner">
      <div className="vacation-banner-icon">🌴</div>
      <div className="vacation-banner-content">
        <div className="vacation-banner-title">{t('vacation_scheduled')}</div>
        <div className="vacation-banner-dates">
          {formatDate(startDate)} - {formatDate(endDate)}
        </div>
      </div>
    </div>
  );
};
